import { ChatWidget } from '@ksyos/chat';
import { Box } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import type { IReduxState } from '@frontend/configureStore';
import { getDisplayName } from '@common/utils/getDisplayName';
import { useFeatureFlag } from '@frontend/utils/hooks/useFeatureFlag';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';

export function Chat() {
    const {
        frontendSettings: { aiChatbotApiUrl, aiChatbotSocketUrl },
    } = useFrontendSettings();

    const { organizationId: currentUserOrganizationId } = useSelector((state: IReduxState) => state.authentication);
    const aiChatbotEnabledPractitioners = useFeatureFlag('AI_CHATBOT_ENABLED_PRACTITIONERS', []);
    const aiChatbotEnabled = aiChatbotEnabledPractitioners.includes(currentUserOrganizationId);
    if (!aiChatbotEnabled) {
        return;
    }
    const { colors } = useTheme();

    const { nameFamily, nameGiven, nameInfix, emailAddress } = useSelector(
        (state: IReduxState) => state.authentication
    );

    const displayName = getDisplayName({ nameFamily, nameGiven, nameInfix }, false, 'familyNameCommaFirstName');
    const nameWithEmail = `${displayName} (${emailAddress})`;

    return (
        <Box
            position="relative"
            zIndex="10"
        >
            <ChatWidget
                apiUrl={aiChatbotApiUrl}
                generalColor={colors.magenta700}
                imageUrl="/assets/images/logo-ksyos-icon.svg"
                initiatorId={'2'} // TODO: replace with selectedEmploymentId but backend expects an integer, so we need to fix that first
                messageIncomingColor={colors.neutral100}
                messageOutgoingColor={colors.magenta300}
                name={nameWithEmail}
                organisationId={'0'} // TODO: replace with organizationId but backend expects an integer, so we need to fix that first
                socketUrl={aiChatbotSocketUrl}
            />
        </Box>
    );
}
